import api from './index'
import { axios } from '@/utils/request'
import qs from 'qs'

export function getItemList () {
  return axios({
    url: api.ItemList,
    method: 'get'
  })
}

export function createItem (parameter) {
  return axios({
    url: api.CreateItem,
    method: 'post',
    data: qs.stringify(parameter)
  })
}

export function deleteItem (item_id) {
  return axios({
    url: api.DeleteItem + '/' + item_id,
    method: 'delete'
  })
}

export function getItemInfo (item_id) {
  return axios({
    url: api.ItemInfo,
    method: 'get',
    params: { item_id: item_id }
  })
}

export function editItem (params) {
  return axios({
    url: api.EditItem,
    method: 'put',
    params: params
  })
}
export function transferItem (params) {
  return axios({
    url: api.TransferItem,
    method: 'put',
    params: params
  })
}

export function itemCollection () {
  return axios({
    url: api.ItemCollection,
    method: 'get'
  })
}

export function recoverItem (params) {
  return axios({
    url: api.ItemRecover,
    method: 'put',
    params: params
  })
}